(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[194],{

/***/ 3554:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/[sessionSlug]",
      function () {
        return __webpack_require__(1510);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2125);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SectionHeading = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-92e95595-0"
})(_templateObject(), function(p) {
    return p.theme.typo.sizes.normal;
});
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeading);


/***/ }),

/***/ 2646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ StyledTinyCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2125);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7966);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  background: ",
        ";\n  border-radius: 20px;\n  box-shadow: inset 0 0 0 1px ",
        ";\n  color: inherit;\n  text-decoration: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n\n    > a {\n      flex-grow: 1;\n      ",
        "\n      transition: \n        background .3s ease-out,\n        color .3s ease-out;\n\n      &:hover {\n        background: ",
        ";\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n\n  p:first-child {\n    margin: 0;\n    padding: 1rem 1.2rem;\n    font-weight: 600;\n    font-size: ",
        ";\n    border-bottom: 1px solid ",
        ";\n  }\n\n  h3 {\n    margin: 0;\n    padding: 1.2rem;\n    ",
        ";\n    font-size: ",
        ";\n    line-height: 1.15;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



function TinyCard(param) {
    var _href = param.href, href = _href === void 0 ? null : _href, _icon = param.icon, icon = _icon === void 0 ? null : _icon, type = param.type, title = param.title;
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTinyCard, {
            $asLink: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TinyCardContent, {
                    icon: icon,
                    type: type,
                    title: title
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTinyCard, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TinyCardContent, {
            icon: icon,
            type: type,
            title: title
        })
    });
}
function TinyCardContent(param) {
    var type = param.type, title = param.title, _icon = param.icon, icon = _icon === void 0 ? null : _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    icon,
                    type
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: title
            })
        ]
    });
}
var cardWrapStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), function(p) {
    return p.theme.colors.ivory;
}, function(p) {
    return p.theme.colors.warmLightGrey;
});
var StyledTinyCard = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cf0132bb-0"
})(_templateObject2(), function(p) {
    return !p.$asLink && cardWrapStyles;
}, function(p) {
    return p.$asLink && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), cardWrapStyles, p.theme.colors.black, p.theme.colors.white);
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.colors.warmLightGrey;
}, function(p) {
    return p.theme.typo.sentientLight;
}, function(p) {
    return p.theme.typo.sizes.bumped;
});
/* harmony default export */ __webpack_exports__["Z"] = (TinyCard);


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _sessionSlug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/AppChrome.tsx + 22 modules
var AppChrome = __webpack_require__(5368);
// EXTERNAL MODULE: ./components/Hero.tsx
var Hero = __webpack_require__(1547);
// EXTERNAL MODULE: ./components/MainContent.tsx + 3 modules
var MainContent = __webpack_require__(6125);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(9851);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(5076);
// EXTERNAL MODULE: ./components/SectionHeading.tsx
var SectionHeading = __webpack_require__(1849);
// EXTERNAL MODULE: ./components/TinyCard.tsx
var TinyCard = __webpack_require__(2646);
;// CONCATENATED MODULE: ./components/SessionChunks.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  margin: calc( var( --grid-gutter ) / -2 );\n\n  > * {\n    margin: calc( var( --grid-gutter ) / 2 );\n  }\n\n  @media ( min-width: 650px ) {\n    grid-template-columns: repeat( 3, 1fr );\n  }\n\n  ",
        " {\n    a {\n      background: ",
        ";\n      box-shadow: none;\n\n      p:first-child {\n        border-bottom-color: ",
        ";\n      }\n\n      &:hover {\n        background: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function SessionChunks(param) {
    var chunks = param.chunks, sessionId = param.sessionId;
    if (!(chunks === null || chunks === void 0 ? void 0 : chunks.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            $top: 4,
            $between: 1.5,
            $bottom: 5,
            $responsive: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading/* default */.Z, {
                    children: "Explore this session"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid, {
                    children: chunks.map(function(chunk, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TinyCard/* default */.Z, {
                            href: "/course/chunks/".concat(chunk.slug, "?sessionId=").concat(sessionId),
                            type: chunk.chunkType.length > 0 && "".concat(i + 1, ". ").concat(chunk.chunkType[0].title),
                            title: chunk.title
                        }, chunk.id);
                    })
                })
            ]
        })
    });
}
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2905e2f4-0"
})(_templateObject(), TinyCard/* StyledTinyCard */.o, function(p) {
    return p.theme.colors.orangeShade;
}, function(p) {
    return p.theme.colors.orange;
}, function(p) {
    return p.theme.colors.black;
});
/* harmony default export */ var components_SessionChunks = (SessionChunks);

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(6502);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(7966);
// EXTERNAL MODULE: ./components/icons/Chevron.tsx
var Chevron = __webpack_require__(9181);
;// CONCATENATED MODULE: ./components/PrevNextButtons.tsx
function PrevNextButtons_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PrevNextButtons_templateObject() {
    var data = PrevNextButtons_taggedTemplateLiteral([
        "\n  display: flex;\n  margin: -4px;\n"
    ]);
    PrevNextButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = PrevNextButtons_taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  flex: 0 0 50%;\n  padding: 4px;\n\n  a,\n  span {\n    display: flex;\n    ",
        "\n    font-size: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 100px;\n    white-space: nowrap;\n\n    i,\n    div {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0.7rem 0.7rem;\n    }\n\n    i {\n      flex-grow: 1;\n      font-style: normal;\n    }\n  }\n\n  a {\n    text-decoration: none;\n    color: inherit;\n    transition: background .3s ease-out;\n\n    &:hover {\n      background: ",
        ";\n    }\n  }\n\n  span {\n    opacity: 0.6;\n  }\n\n  &:first-child {\n    a,\n    span {\n      flex-direction: row-reverse;\n\n      i {\n        padding-right: 1.1rem;\n        border-left: 1px solid ",
        ";\n      }\n\n      div {\n        padding-left: 0.9rem;\n      }\n    }\n  }\n  \n  &:last-child {\n    a,\n    span {\n      i {\n        padding-left: 1.1rem;\n      }\n\n      div {\n        padding-right: 0.9rem;\n        border-left: 1px solid ",
        ";\n      }\n    }\n  }\n\n  @media ( max-width: 350px ) {\n    a,\n    span {\n      font-size: ",
        ";\n\n      i,\n      div {\n        padding: 0.5rem 0.5rem;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function PrevNextButtons(param) {
    var _nextHref = param.nextHref, nextHref = _nextHref === void 0 ? null : _nextHref, _nextText = param.nextText, nextText = _nextText === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Next"
    }) : _nextText, _prevHref = param.prevHref, prevHref = _prevHref === void 0 ? null : _prevHref, _prevText = param.prevText, prevText = _prevText === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Previous"
    }) : _prevText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrevNextButtons, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                href: prevHref,
                text: prevText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                    left: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                href: nextHref,
                text: nextText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                    right: true
                })
            })
        ]
    });
}
function Button(param) {
    var href = param.href, text = param.text, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
        $disabled: !href,
        children: [
            href && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                href: href,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: text
                    }),
                    children
                ]
            }),
            !href && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: text
                    }),
                    children
                ]
            })
        ]
    });
}
var StyledPrevNextButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-247173cf-0"
})(PrevNextButtons_templateObject());
var StyledButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-247173cf-1"
})(_templateObject1(), function(p) {
    return p.theme.typo.switzer;
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return (0,polished_esm/* rgba */.m4)(p.theme.colors.black, 0.1);
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.typo.sizes.tiny;
});
/* harmony default export */ var components_PrevNextButtons = (PrevNextButtons);

;// CONCATENATED MODULE: ./pages/course/[sessionSlug].tsx






function SessionPage(param) {
    var session = param.entry, sessions = param.sessions;
    var sessionNumber = session.lft / 2;
    var thisSessionIndex = sessions.findIndex(function(s) {
        return s.lft === session.lft;
    });
    var prevSessionUrl = function() {
        if (thisSessionIndex > -1 && thisSessionIndex > 0) {
            return "/course/".concat(sessions[thisSessionIndex - 1].slug);
        }
        return null;
    };
    var nextSessionUrl = function() {
        if (thisSessionIndex > -1 && thisSessionIndex < sessions.length - 1) {
            return "/course/".concat(sessions[thisSessionIndex + 1].slug);
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppChrome/* default */.Z, {
        color: "orange",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                ui: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PrevNextButtons, {
                    prevText: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "Previous",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "\xa0session"
                            })
                        ]
                    }),
                    nextText: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "Next",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "\xa0session"
                            })
                        ]
                    }),
                    prevHref: prevSessionUrl(),
                    nextHref: nextSessionUrl()
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            "Session ",
                            sessionNumber
                        ]
                    }),
                    session.title
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContent/* default */.Z, {
                contentBlocks: session.contentBlocks,
                session: session
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SessionChunks, {
                chunks: session.chunks,
                sessionId: session.id
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var _sessionSlug_ = (SessionPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3554); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);